export const isValidHexValue = (hexValue) => {
  if (hexValue.length === 7) {
    return /^#[0-9A-Fa-f]{6}$/.test(hexValue);
  }
  if (hexValue.length === 4) {
    return /^#[0-9A-Fa-f]{3}$/.test(hexValue);
  }
  return false;
};

export const getRgbArrayFromHexValue = (hexValue) => {
  if (typeof hexValue !== 'string') return null;
  let hexString = hexValue.trim();
  if (hexString[0] === '#') hexString = hexString.slice(1);

  if (!/^[\da-f]{3}([\da-f]{3})?$/i.test(hexString)) return null;
  if (hexString.length === 3)
    hexString = hexString
      .split('')
      .map((c) => c + c)
      .join('');

  const hexArray = hexString.match(/.{2}/g);
  if (!hexArray) return null;

  return hexArray.map((c) => parseInt(c, 16));
};

export const isColorNearlyWhite = (hexValue, threshold = 252) => {
  if (!hexValue) return false;
  if (hexValue === 'transparent') return true;

  const rgbArray = getRgbArrayFromHexValue(hexValue);
  if (!rgbArray) return false;
  return Math.min(...rgbArray) >= threshold;
};
